import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer-pill" }


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const currentYear = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_1, " Nasta © " + _toDisplayString(_unref(currentYear)) + " - Sva prava pridržana ", 1)
    ])
  ], 64))
}
}

})